import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogConfig,
} from "@angular/material/dialog";
import { Component, OnInit, Inject } from "@angular/core";
import { firstValueFrom } from "rxjs";

@Component({
  selector: "app-confirm-dialog",
  templateUrl: "./confirm-dialog.component.html",
  styleUrls: ["./confirm-dialog.component.css"],
})
export class ConfirmDialogComponent implements OnInit {
  title: string;
  message: string;

  constructor(
    public dialogRef: MatDialogRef<ConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmDialogModel,
  ) {
    // Update view with given values
    this.title = data.title;
    this.message = data.message;
  }

  ngOnInit() {}

  onConfirm(): void {
    // Close the dialog, return true
    this.dialogRef.close(true);
  }

  onDismiss(): void {
    // Close the dialog, return false
    this.dialogRef.close(false);
  }
}

/**
 * Class to represent confirm dialog model.
 *
 * It has been kept here to keep it as part of shared component.
 */
export class ConfirmDialogModel {
  constructor(
    public title: string,
    public message: string,
  ) {}
}

export async function openConfirmDialog(
  dialog: MatDialog,
  message: string,
  title = "Confirm",
  config?: MatDialogConfig<ConfirmDialogModel>,
): Promise<boolean> {
  const ref = dialog.open<ConfirmDialogComponent, ConfirmDialogModel, boolean>(
    ConfirmDialogComponent,
    {
      width: "420px",
      disableClose: true,
      data: new ConfirmDialogModel(title, message),
      ...(config ?? {}),
    },
  );
  const result = await firstValueFrom(ref.afterClosed());
  return result === true;
}

/** Specialization for “leave without saving” for form sections. */
export function confirmLeaveWithoutSaving(
  dialog: MatDialog,
  message = "This section could not be saved. Leave without saving and continue?",
  title = "Unsaved Changes",
  config?: MatDialogConfig<ConfirmDialogModel>,
): Promise<boolean> {
  return openConfirmDialog(dialog, message, title);
}
